import { PrivilegeChecker } from 'omni-common-ui';
import is from 'is_js';
import Privileges from 'domain/Privileges';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import { routes as dosApprovalList } from './DosApprovalList';
import { routes as studentReportView } from './StudentReportView';
import { generateActionButtons } from './ProgressReportListView/routes';
import { getProgressReportById } from 'data/ProgressReports/accessors';
import ProgressReports from './component';
import ProgressReportListView from './ProgressReportListView';
import ProgressReportSessionNav from 'components/ProgressReportSessionNav';
import ViewNav from 'components/ViewNav';
import { actions as groupAction } from 'containers/Group';

export default ({ getState }) => ({
  appBars: {
    sticky: {
      navigation: {
        component: ProgressReportSessionNav,
        order: 1,
      },
      'view-nav': {
        component: ViewNav,
        order: 3,
      },
    },
  },
  path: 'unit-report-hfv4(/:progressReportId)',
  component: ProgressReports,
  indexRoute: {
    component: ProgressReportListView,
    actionButtons: {
      default: generateActionButtons(getState),
      'export-all': generateActionButtons(getState),
    },
  },
  canAccess: ({ params }) =>
    PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressReport.View) &&
    TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.UnitReportHFv4),
  breadcrumbLabels: ({ buildRoute, params }) => {
    const { progressReportId, groupId } = params;
    const progressReport = getProgressReportById(getState(), progressReportId);
    if (! is.existy(progressReport)) {
      return [];
    }
    return {
      label: progressReport.name,
      href: buildRoute(`/group/${groupId}/unit-report-hfv4/${progressReportId}`),
    };
  },
  tab: {
    label: (params) => (groupAction.isDisabledReportActions(getState(), params.groupId) ?
      'Historical Unit Reports' :
      'Unit Reports'),
    order: 7,
    isVisible: (params) =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressReport.View) &&
      TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.UnitReportHFv4),
  },
  childRoutes: [
    dosApprovalList,
    studentReportView,
    {
      path: ':mode',
      component: ProgressReportListView,
      actionButtons: {
        default: generateActionButtons(getState),
        'export-all': generateActionButtons(getState),
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/routes.js